/** cita_plan_consumo.estado */
export const CONSUMO_PENDIENTE = 0;
export const CONSUMO_ACTIVO = 1;
export const CONSUMO_ANULADO = 2;

/** paciente_plan_agendamiento.estado */
export const PLAN_ACTIVO = 0;
export const PLAN_AGOTADO = 1;
export const PLAN_ANULADO = 2;
export const PLAN_VENCIDO = 3;

const PLAN_LABELS = {
    0: "activo",
    1: "agotado",
    2: "anulado",
    3: "vencido",
    activo: "activo",
    agotado: "agotado",
    completado: "agotado",
    anulado: "anulado",
    vencido: "vencido",
};

const PLAN_ETIQUETAS = {
    activo: "activo",
    agotado: "completado",
    anulado: "anulado",
    vencido: "vencido",
};

export function normalizarEstadoPlan(estado) {
    if (estado === null || estado === undefined || estado === "") return "";
    if (typeof estado === "number" || /^-?\d+$/.test(String(estado).trim())) {
        const n = Number(estado);
        return PLAN_LABELS[n] || String(estado);
    }
    return String(estado).toLowerCase().trim();
}

export function esPlanActivo(estado) {
    return normalizarEstadoPlan(estado) === "activo";
}

export function esConsumoActivo(estado) {
    const n = Number(estado);
    if (!Number.isNaN(n) && n === CONSUMO_ACTIVO) return true;
    return String(estado || "").toLowerCase() === "activo";
}

export function puedeAnularPlan(estado) {
    const val = normalizarEstadoPlan(estado);
    return val === "activo" || val === "agotado" || val === "vencido";
}

/** True si el plan ya tiene consumo o reservas registradas (no se puede eliminar). */
export function planTieneSesionesRegistradas(block) {
    if (!block) return false;
    const usadas = (block.detalle || []).reduce(
        (acc, d) => acc + (Number(d.sesiones_usadas) || 0),
        0
    );
    if (usadas > 0) return true;
    return (block.atenciones || []).length > 0;
}

export function puedeEliminarPlanPaciente(block) {
    return !planTieneSesionesRegistradas(block);
}

export function etiquetaEstadoPlan(estado) {
    const val = normalizarEstadoPlan(estado);
    return PLAN_ETIQUETAS[val] || val;
}
